const updateCurrentSubscriptionType = subscriptionType => ({
  type: 'SET:CURRENT_SUBSCRIPTION_TYPE',
  subscriptionType
})

const updateSubscriptionTypePromoCode = promoCode => ({
  type: 'SET:SUBSCRIPTION_TYPE_PROMO_CODE',
  promoCode
})

const updateSubscriptionTypeIds = ids => ({
  type: 'SET:SUBSCRIPTION_TYPE_IDS',
  ids
})

const resetSubscriptionTypeIds = () => ({
  type: 'RESET:SUBSCRIPTION_TYPE_IDS'
})

const updateCurrentPlanAutoRenewStatus = status => ({
  type: 'SET:PLANS_AUTO_RENEW_STATUS',
  status
})

const getCancelQuestionarie = url => ({
  type: 'API:PLANS:QUESTIONARIE',
  API: true,
  method: 'GET',
  url
})

const getLeaveQuestionarie = url => ({
  type: 'API:QUESTIONARIE:LEAVE',
  API: true,
  method: 'GET',
  url
})

const updateInPlansStatus = inPlans => ({
  type: 'SET:INPLANS',
  inPlans
})

const resetCurrentSubscriptionType = () => ({
  type: 'SET:RESET_CURRENT_SUBSCRIPTION_TYPE'
})

export default {
  updateCurrentSubscriptionType,
  updateSubscriptionTypeIds,
  updateSubscriptionTypePromoCode,
  resetSubscriptionTypeIds,
  updateCurrentPlanAutoRenewStatus,
  updateInPlansStatus,
  getCancelQuestionarie,
  getLeaveQuestionarie,
  resetCurrentSubscriptionType
}
